import script from "./DateChange.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateChange.vue?vue&type=script&setup=true&lang=ts"

import "./DateChange.vue?vue&type=style&index=0&id=e25f9b8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e25f9b8e"]])

export default __exports__